import { memo } from "react";
import { useNavigate } from "react-router-dom";
import { cdnImg } from "../Utils/cdnImage";
import { FaFireAlt } from "react-icons/fa";
import { HomePlatformList } from "../Pages/casino/ListHome";
import { isMobile } from "react-device-detect";
import { startCase } from "lodash";
import { useContextSelector } from "use-context-selector";
import ThemeContext from "../context/ThemeContext";
const HomeSliderCasinoList = () => {
  const navigate = useNavigate();
  const theme = useContextSelector(ThemeContext, (ctx) => {
    return ctx.theme;
  });
  return isMobile ? (
    <div
      style={{ height: "100%", background: "transparent", margin: "1.8vw" }}
      className="search-tab brand-tab casino-platform-slider"
    >
      <ul
        style={{
          display: "grid",
          gridAutoFlow: "column",
          gridTemplateRows: "repeat(2, 1fr)",
          gridAutoColumns: "100px",
          padding: "0",
          margin: "0",
          gridGap: "3px",
          overflowX: "scroll",
        }}
        className="item-ani ng-tns-c2684251700-888"
      >
        {HomePlatformList?.map((res) => {
          return (
            <li
              onClick={() => {
                navigate(
                  res?.name == "hot"
                    ? `/casino?type=hot`
                    : res?.name == "All"
                      ? `/casino?type=all&provider=all`
                      : `/casino?type=all&provider=${res?.vendor}`,
                );
              }}
              style={
                theme == "dark"
                  ? {
                      height: "9vw",
                      background: "#012526",
                      border: ".32vw solid #012526",
                      borderRadius: "20px",
                    }
                  : {
                      height: "9vw",
                      background: "#37383c",
                      border: "0.32vw solid #37383c",
                      borderRadius: "20px",
                    }
              }
              className={`condition-groups`}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100%",
                  flexDirection: "row",
                }}
                className="condition-groups__inner ng-tns-c2684251700-888 ng-star-inserted"
              >
                {res?.name == "hot" ? (
                  <FaFireAlt color="red" size={20} />
                ) : (
                  <img
                    style={{ height: "7.5vw", width: "7.5vw" }}
                    className="ng-tns-c2684251700-888"
                    alt="provider-awcmpt"
                    src={
                      res?.name == "All"
                        ? "/assets/image-1772134978923.png"
                        : cdnImg(res?.src)
                    }
                    loading="lazy"
                  />
                )}
                <span
                  style={{
                    color: "white",
                    fontSize: "11px",
                    marginLeft: "5px",
                    fontWeight: "600",
                    color: "#ffb80c",
                  }}
                >
                  {res?.name == "All" ? "All Casino" : startCase(res?.name)}
                </span>
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  ) : (
    <div className="main-wrapper ng-star-inserted">
      <div
        _ngcontent-serverapp-c2028772222
        className="icon-marquee ng-star-inserted"
      >
        <div _ngcontent-serverapp-c2028772222 className="icon-marquee__content">
          <ul _ngcontent-serverapp-c2028772222>
            {HomePlatformList?.map((res) => {
              return (
                <li
                  onClick={() => {
                    navigate(
                      res?.name == "hot"
                        ? `/casino?type=hot`
                        : res?.name == "All"
                          ? `/casino?type=all&provider=PP`
                          : `/casino?type=all&provider=${res?.vendor}`,
                    );
                  }}
                  _ngcontent-serverapp-c2028772222
                  className="ng-star-inserted"
                >
                  {res?.name == "hot" ? (
                    <FaFireAlt color="orange" size={20} />
                  ) : (
                    <img
                      alt={res?.name}
                      src={
                        res?.name == "All"
                          ? "/assets/image-1772134978923.png"
                          : cdnImg(res?.src)
                      }
                    />
                  )}{" "}
                  <span
                    style={{
                      color: "white",
                      fontSize: "11px",
                      marginLeft: "5px",
                      color: "#ffb80c",
                    }}
                  >
                    {startCase(res?.name)}
                  </span>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default memo(HomeSliderCasinoList);
